import { Component, OnDestroy, OnInit } from '@angular/core'
import { BreadcrumbService } from '../../../../services/breadcrumb.service'
import { TableData } from '../../../../modules/dto'
import 'brace'
import 'brace/mode/json'
import 'brace/mode/python'
import 'brace/snippets/python'
import 'brace/ext/language_tools'
import 'brace/theme/github'
import { AceConfigInterface } from 'ngx-ace-wrapper'
import { ScriptActionsState } from '../../../../models/script-actions-state.model'
import { BaseNavStateComponent } from '../../../navigation-state/components/base-component/base-nave-state.component'
import { ActivatedRoute, Router } from '@angular/router'
import { JmlNavAdapterService } from '../../../navigation-state/services/jml-nav-adapter.service'
import { map, take, tap } from 'rxjs/operators'
import { ActionService } from '../../services/action.service'
import { JmlTitleService } from 'projects/jml-lib/src/lib/services/jml-title.service'
import { EntityConfigService } from '../../../dto'
import { Observable } from 'rxjs'

@Component({
  selector: 'jml-lib-script-actions',
  templateUrl: './script-actions.component.html',
  styleUrls: ['./script-actions.component.scss']
})
export class ScriptActionsComponent extends BaseNavStateComponent<ScriptActionsState> implements OnInit, OnDestroy {
  data = new TableData('ScriptAction')
  code: string
  aceconfig: AceConfigInterface
  loading = false
  result = ''
  output = ''
  globalActions$: Observable<any[]>

  constructor(
    private breadcrumbService: BreadcrumbService,
    private actionService: ActionService,
    private entityConfigService: EntityConfigService,
    jmlNav: JmlNavAdapterService,
    route: ActivatedRoute,
    router: Router,
    private titleService: JmlTitleService
  ) {
    super(jmlNav, route, router)
    this.breadcrumbService.setItems([{ label: 'Aktionen' }])
  }

  ngOnInit() {
    // is this component a top level comp (is this component referenced in the route)?
    const isRouteComp = true
    // will this component provide a custom identifier?
    const hasCustomComponentIdentifier = false
    // initialize pre-ngOnInit-setting for base class.
    this.initNavStateSettings(isRouteComp, hasCustomComponentIdentifier)
    super.ngOnInit()

    this.titleService.setAppTitle('Skript IDE')

    this.aceconfig = {
      theme: 'github',
      readOnly: false
    }

    // load state from store (if state exists)
    this.initWithExistingState$
      .pipe(
        tap((state) => {
          this.code = state.code
        })
      )
      .subscribe()

    // load global actions for ScriptAction
    this.globalActions$ = this.entityConfigService
      .getConfig$('ScriptAction')
      .pipe(map((config) => config?.globalActions))
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  // continously save changes to ngrx store
  onChange(codeChange: string) {
    if (!codeChange) {
      return
    }
    const state = new ScriptActionsState()
    state.code = codeChange
    this.saveState(state)
  }

  execute() {
    this.loading = true
    const payload = { snippet: this.code, entityReference: null, context: null }
    const actionRequest$ = this.actionService.executeCodeSnippet(payload).pipe(take(1))
    actionRequest$.subscribe(
      (response) => {
        this.loading = false
        this.result = response['result']
        this.output = response['output']
      },
      (error) => {
        this.loading = false
        this.result = error.error.message
        this.output = error.error.trace
      }
    )
  }

  delete() {
    this.code = ''
    this.result = ''
    this.output = ''
    this.removeState()
  }

  performAction(actionHrid: string, actionButton: any) {
    actionButton.inProgress = true
    this.actionService.performAction(actionHrid, undefined, undefined, (success) => {
      actionButton.inProgress = false
    })
  }
}
